import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Months as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const RevnewProfit2 = () => {
  const labels = Array.from({ length: 60 }, (_, i) => `Month ${i + 1}`);

  const totalBusinessRevenue = [
    213461.77, 233259.13, 179855.38, 284913.81, 298849.10, 140310.03, 130815.54,
    229654.64, 268087.54, 340686.68, 290763.96, 390460.95, 396058.25, 281630.97,
    380941.40, 163002.62, 298429.72, 317340.79, 259166.33, 264331.45, 473312.27,
    306297.58, 431119.76, 511417.09, 290797.80, 664716.23, 468853.39, 278750.90,
    393884.11, 439896.13, 423622.83, 695962.68, 439116.70, 654640.38, 696707.61,
    823193.47, 607552.88, 828098.73, 887588.95, 527446.15, 710192.76, 793427.14,
    741770.21, 853437.99, 494183.87, 536166.33, 485406.72, 537031.67, 678081.00,
    835870.11, 611706.76, 727534.52, 645969.92, 414858.70, 568370.39, 766794.09,
    697307.33, 785481.01, 1050731.44, 680434.59,
  ];

  const EBIT = [
    11145.05, -13337.99, 33426.89, 10811.76, 63414.44, 343.86, -15311.94,
    11136.52, 4176.07, 20599.77, 95693.00, -8581.34, 693.22, 41004.29,
    -28130.77, -28493.00, -19857.36, -20756.55, -26982.05, -81590.77,
    121881.32, 19213.94, -41117.60, 67053.78, -3016.05, 64286.24, 22371.42,
    28345.72, 100755.66, -38832.08, 31821.47, 58714.51, 21217.14, 86222.95,
    -23680.79, 140693.63, 101469.23, -30299.90, 84071.34, -18945.78, 20471.34,
    -50677.53, 30957.49, 8057.85, -130115.55, 14979.70, -51434.81, 80015.15,
    84801.14, 157455.56, 8496.97, 11592.39, 14030.86, 9757.90, 173857.98,
    -24353.01, -54839.87, 127709.09, 161986.21, 73851.97,
  ];

  const normalisedEBIT = [
    11145.05, 13300.72, 34364.32, 10811.76, 63414.44, 343.86, -15163.99,
    11136.52, 4280.58, 20872.77, 96161.91, -8445.14, 827.77, 41305.04,
    -25870.63, -27583.91, -20639.65, -20551.95, -26982.05, -81507.69,
    121881.32, 19717.21, -79932.51, 68553.78, -2407.05, 64486.24, 24188.59,
    28345.72, 100824.75, -38377.08, 32457.83, 58714.51, 21217.14, 86450.22,
    -23298.79, 140693.63, 101469.23, -30299.90, 85537.96, -14890.27, 20471.34,
    -50677.53, 31093.85, 8057.85, -129765.55, 15206.97, -49783.90, 80015.15,
    84801.14, 159455.56, 8744.02, 11942.39, 14830.86, 11270.90, 174233.25,
    -22387.56, -54839.87, 127874.73, 162307.21, 74851.97,
  ];

  const trendLineEBIT = getLinearTrend(EBIT);
  const trendLineRevenue = getLinearTrend(totalBusinessRevenue);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Total Business Revenue", "EBIT", "Normalised EBIT", "Trend Line (EBIT)", "Trend Line (Revenue)"] },
    xAxis: { type: "category", data: labels },
    yAxis: { type: "value" },
    series: [
      {
        name: "Total Business Revenue",
        type: "line",
        data: totalBusinessRevenue,
        smooth: true,
      },
      {
        name: "EBIT",
        type: "line",
        data: EBIT,
        smooth: true,
      },
      {
        name: "Normalised EBIT",
        type: "line",
        data: normalisedEBIT,
        smooth: true,
      },
      {
        name: "Trend Line (Revenue)",
        type: "line",
        data: trendLineRevenue,
        smooth: true,
        lineStyle: { type: 'dashed', color: 'blue' },
      },
      {
        name: "Trend Line (EBIT)",
        type: "line",
        data: trendLineEBIT,
        smooth: true,
        lineStyle: { type: 'dashed', color: 'green' },
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default RevnewProfit2;
